import React from 'react'
import { useTranslation } from 'react-i18next'
import {
  IconButton,
  Refresh as RefreshIcon,
  Analysis as AnalysisIcon,
  Info as InfoIcon,
  Tooltip
  // @ts-ignore
} from '@netbasequid/core'
// @ts-ignore
import { sys } from '@netbasequid/theme'
import { usePage, useDisplayTheme } from 'hooks/useUiState'
import { Page } from 'features/ui/types'
import { DashboardWidgetType } from 'features/dashboard/types'
import { useIsWidgetLoading } from 'hooks/useWidgetState'
import { useAppDispatch } from 'app/hooks'
import { updateRefreshOnDemands } from 'features/ui/uiSlice'
import { sendTypedMessage } from 'utils/iframeUtil'
import { toExternal } from 'vo/util'
import { ActionButtonsContainer, ButtonHoverWrapper, StyledInfoIconContainer } from './index.css'
import InfoContent from './InfoContent'
// import VizWebhookButton from './VizWebhookButton'
// import VizFormButton from './VizFormButton'
// import VizSchedulerButton from './VizSchedulerButton'

interface ActionButtonsProps {
  widgetSetting: DashboardWidgetType
}

const ActionButtons = ({ widgetSetting }: ActionButtonsProps) => {
  const page = usePage()
  const { t } = useTranslation()
  const displayTheme = useDisplayTheme()
  const isWidgetLoading = useIsWidgetLoading(widgetSetting.widgetId!)
  const dispatch = useAppDispatch()
  const hasInaccessibleTopic = widgetSetting.topicInfos?.some((topic) => topic.accessible === false)

  const handleRefreshClick = () => {
    dispatch(updateRefreshOnDemands({ widgetId: widgetSetting.widgetId! }))
  }

  if (page === Page.LiveReport) {
    return null
  }

  function goToAnalysis() {
    sendTypedMessage('goToAnalysis', toExternal(widgetSetting))
  }

  return (
    <ActionButtonsContainer>
      <Tooltip mode={displayTheme} content={t('refreshWidgetData')}>
        <IconButton
          mode={displayTheme}
          color="regular"
          variant="clickable"
          disabled={isWidgetLoading}
          onClick={handleRefreshClick}>
          <RefreshIcon color={sys[displayTheme].text.placeholder} />
        </IconButton>
      </Tooltip>
      {/* <VizFormButton widgetSetting={widgetSetting} isWidgetLoading={isWidgetLoading} />
      <VizWebhookButton widgetSetting={widgetSetting} isWidgetLoading={isWidgetLoading} />
      <VizSchedulerButton widgetSetting={widgetSetting} isWidgetLoading={isWidgetLoading} /> */}
      <Tooltip
        enabled={!isWidgetLoading}
        mode={displayTheme}
        content={
          !isWidgetLoading && hasInaccessibleTopic ? t('cannotGoToAnalysis') : t('goToAnalysis')
        }>
        <ButtonHoverWrapper>
          <IconButton
            disabled={isWidgetLoading || hasInaccessibleTopic}
            mode={displayTheme}
            color="regular"
            variant="clickable"
            onClick={() => goToAnalysis()}>
            <AnalysisIcon color={sys[displayTheme].text.placeholder} />
          </IconButton>
        </ButtonHoverWrapper>
      </Tooltip>
      <Tooltip
        mode={displayTheme}
        content={<InfoContent widgetSetting={widgetSetting} />}
        followCursor={false}
        interactive
        offset={[0, 0]}>
        <StyledInfoIconContainer>
          <InfoIcon color={sys[displayTheme].text.placeholder} />
        </StyledInfoIconContainer>
      </Tooltip>
    </ActionButtonsContainer>
  )
}

export default ActionButtons
